import { $, w } from './constants'

w.load(() => {
    console.log('Hello world from El Cultivo! --Load')
    //coming soon
    if ($('.bg-dk').length) {
        if ($(window).width() < 968) {
            $('.bg-dk').css('background-image', 'url(' + bgM + ')')
        } else if ($(window).width() > 968) {
            $('.bg-dk').css('background-image', 'url(' + bgD + ')')
        }
    }

    //Cookies
    if (localStorage.getItem('alqqamar-cookies')) {
        $('#cookies_alqqamar').addClass('hide')
    } else {
        $('#cookies_alqqamar').delay(1000).fadeIn(500)
        $('#accept_cookies, #close_cookies').click(() => {
            localStorage.setItem('alqqamar-cookies', 'true')
            $('#cookies_alqqamar').fadeOut(200).addClass('hide')
        })
    }
})

$(document).ready(function () {
    console.log('Hello world from El Cultivo! --Ready')
    $('#account_submenu').on('click', function () {
        $(this).toggleClass('active')
        $('#account_submenu_target').slideToggle(200).toggleClass('active')
    })
    $('#filter_submenu').on('click', function () {
        $(this).toggleClass('active')
        $('#filter_submenu_target').slideToggle(200).toggleClass('active')
    })

    /* C L O S E : Search */
    $('.input--search-desktop').on('input', function () {
        toggleCloseButton()
    })
    function toggleCloseButton() {
        let searchInput = $('.input--search-desktop')
        let closeButton = $('.close-search')

        if (searchInput.val().trim() !== '') {
            closeButton.show()
        } else {
            closeButton.hide()
        }
    }
    /* END C L O S E : Search */

    /* B O U T I Q U E : Filter & Search */
    // $('.category-item').on('click', function () {
    //     $('.category-in-list').removeClass('active')
    //     $(this).addClass('active')
    //     let cat = $(this).data('category')
    //     let search = $('#product-search-form').find('input[name="s"]')
    //     search.val('')
    //     $('.boutique__mask').fadeIn(50)
    //     $('body').addClass('body-loader')
    //     $.ajax({
    //         type: 'POST',
    //         dataType: 'html',
    //         url: cltvo_js_vars.ajax_url,
    //         data: { action: 'product_filter', category: cat, search: null },
    //         success: function (data) {
    //             $('#grid-container').html(data)
    //         },
    //         error: function (errors) {
    //             console.log(errors)
    //         },
    //         complete: function () {
    //             $('.boutique__mask').fadeOut(30)
    //             $('body').removeClass('body-loader')
    //         },
    //     })
    // })
    // $('.close-search-boutique').on('click', function () {
    //     $('.boutique__mask').fadeIn(50)
    //     $('body').addClass('body-loader')
    //     let searchInput = $('.input--search-desktop')
    //     searchInput.val('')
    //     $(this).hide()
    //     $.ajax({
    //         type: 'POST',
    //         dataType: 'html',
    //         url: cltvo_js_vars.ajax_url,
    //         data: { action: 'product_search', search: null, term: null },
    //         success: function (response) {
    //             $('#grid-container').html(response)
    //         },
    //         error: function (errors) {
    //             console.log(errors)
    //         },
    //         complete: function () {
    //             $('.boutique__mask').fadeOut(30)
    //             $('body').removeClass('body-loader')
    //         },
    //     })
    // })
    // $('#product-search-form').on('submit', function (e) {
    //     e.preventDefault() // Evitar el envío del formulario por defecto
    //     let term = $('#category-list').find('.category-item.active')
    //     $(term).removeClass('active')
    //     $('.cat-all').addClass('active')
    //     let searchTerm = $(this).find('input[name="s"]').val() // Obtener el término de búsqueda
    //     $('.boutique__mask').fadeIn(50)
    //     $('body').addClass('body-loader')
    //     // Realizar la petición AJAX para obtener los productos filtrados
    //     $.ajax({
    //         type: 'POST',
    //         dataType: 'html',
    //         url: cltvo_js_vars.ajax_url,
    //         data: { action: 'product_search', search: searchTerm, term: null },
    //         success: function (response) {
    //             $('#grid-container').html(response)
    //         },
    //         error: function (errors) {
    //             console.log(errors)
    //         },
    //         complete: function () {
    //             $('.boutique__mask').fadeOut(30)
    //             $('body').removeClass('body-loader')
    //         },
    //     })
    // })

    
    /* END B O U T I Q U E : Filter & Search */

    /* M A G A Z I N E : Filter & Search */
    $('.theme-item').on('click', function () {
        $('.theme-in-list').removeClass('active')
        $(this).addClass('active')
        let theme = $(this).data('theme')
        let search = $('#magazine_form_search').find('input[name="s"]')
        $(search).val('')
        $('.close-search').hide()
        $('.boutique__mask').fadeIn(10)
        $('body').addClass('body-loader')
        $.ajax({
            type: 'POST',
            dataType: 'html',
            url: cltvo_js_vars.ajax_url,
            data: { action: 'magazine_filter', term: theme, search: null },
            success: function (data) {
                $('#grid_magazine').html(data)
            },
            error: function (errors) {
                console.log(errors)
            },
            complete: function () {
                $('.boutique__mask').fadeOut(30)
                $('body').removeClass('body-loader')
            },
        })
    })
    $('.close-search-magazine').on('click', function () {
        $('.boutique__mask').fadeIn(50)
        $('body').addClass('body-loader')
        let searchInput = $('.input--search-desktop')
        searchInput.val('')
        $(this).hide()
        $.ajax({
            type: 'POST',
            dataType: 'html',
            url: cltvo_js_vars.ajax_url,
            data: { action: 'magazine_search', search: null, term: null },
            success: function (response) {
                $('#grid_magazine').html(response)
            },
            error: function (errors) {
                console.log(errors)
            },
            complete: function () {
                $('.boutique__mask').fadeOut(30)
                $('body').removeClass('body-loader')
            },
        })
    })
    $('#magazine_form_search').on('submit', function (e) {
        e.preventDefault() // Evitar el envío del formulario por defecto
        let term = $('#theme-list').find('.theme-item.active')
        $(term).removeClass('active')
        $('.theme-all').addClass('active')
        let searchTerm = $(this).find('input[name="s"]').val() // Obtener el término de búsqueda
        $('.boutique__mask').fadeIn(50)
        $('body').addClass('body-loader')
        // Realizar la petición AJAX para obtener los productos filtrados
        $.ajax({
            type: 'POST',
            dataType: 'html',
            url: cltvo_js_vars.ajax_url,
            data: { action: 'magazine_search', search: searchTerm, term: null },
            success: function (response) {
                $('#grid_magazine').html(response)
            },
            error: function (errors) {
                console.log(errors)
            },
            complete: function () {
                $('.boutique__mask').fadeOut(30)
                $('body').removeClass('body-loader')
            },
        })
    })
    /* END M A G A Z I N E : Filter & Search */

    /* A R T  R E A D I N G S : Filter */
    let symbol_val = null
    let minor_val = null
    let major_val = null
    let major_obj, minor_obj, symbol_obj

    const getArtArtcicles = (symbol = null, major = null, minor = null) => {
        $('.boutique__mask').fadeIn(50)
        $('body').addClass('body-loader')
        // Realizar la petición AJAX para obtener los artículos filtrados
        $.ajax({
            type: 'POST',
            dataType: 'html',
            url: cltvo_js_vars.ajax_url,
            data: {
                action: 'art_filter',
                symbol: symbol,
                major: major,
                minor: minor,
            },
            success: function (response) {
                $('#grid_art').html(response)

                $('html, body').animate(
                    {
                        scrollTop: $('#grid_art').offset().top - 120,
                    },
                    100
                )
                if (response.includes('empty')) {
                    $('.acordeon').next('.more_info').slideUp(0)
                    $('.acordeon').removeClass('open')
                }
            },
            error: function (errors) {
                console.log(errors)
            },
            complete: function () {
                $('.boutique__mask').fadeOut(30)
                $('body').removeClass('body-loader')
            },
        })
    }

    $('input[name="symbol_art"]').on('change', function () {
        symbol_val = $(this).val()
        major_obj = $('#major_container').find(
            'input[name="major_arcana"]:checked'
        )
        if ($(major_obj).length) {
            major_val = $(major_obj).val()
        }
        minor_obj = $('#minor_container').find(
            'input[name="minor_arcana"]:checked'
        )
        if ($(minor_obj).length) {
            minor_val = $(minor_obj).val()
        }
        getArtArtcicles(symbol_val, major_val, minor_val)
    })
    $('input[name="major_arcana"]').on('change', function () {
        major_val = $(this).val()
        symbol_obj = $('#symbol_container').find(
            'input[name="symbol_art"]:checked'
        )
        if ($(symbol_obj).length) {
            symbol_val = $(symbol_obj).val()
        }
        minor_obj = $('#minor_container').find(
            'input[name="minor_arcana"]:checked'
        )
        if ($(minor_obj).length) {
            minor_val = $(minor_obj).val()
        }
        getArtArtcicles(symbol_val, major_val, minor_val)
    })
    $('input[name="minor_arcana"]').on('change', function () {
        minor_val = $(this).val()
        symbol_obj = $('#symbol_container').find(
            'input[name="symbol_art"]:checked'
        )
        if ($(symbol_obj).length) {
            symbol_val = $(symbol_obj).val()
        }
        major_obj = $('#major_container').find(
            'input[name="major_arcana"]:checked'
        )
        if ($(major_obj).length) {
            major_val = $(major_obj).val()
        }
        getArtArtcicles(symbol_val, major_val, minor_val)
    })
    /* END A R T  R E A D I N G S : Filter */
})

if ($('#announcement_bar').hasClass('inactive') == false) {
    const bar = $('#announcement_bar').innerHeight() + 156
    document.documentElement.style.setProperty('--bar-top', `${bar}px`)
}

const hamburger = document.querySelector('.hamburger')
const lista = document.querySelector('#mobile')

hamburger.addEventListener('click', mobileMenu)
// lista.addEventListener("click", mobileMenu );

function mobileMenu() {
    hamburger.classList.toggle('active')
    lista.classList.toggle('open')
}

$(window).scroll(function (event) {
    const nav = $('.header')
    const lista = $('.menu-desktop')
    const listaM = $('.menu-mobile')
    const down = $('.header__down')
    const mobile = $('#mobile')
    const hamburguer = $('.hamburger')
    const popup = $('.popup')
    const bar = $('.announcement-bar')
    const up = $('.header__up')
    const cart = $('#shop-pop')

    if ($(this).scrollTop() > 0) {
        nav.addClass('active')
        lista.addClass('active')
        down.addClass('inactive')
        up.addClass('center')
        mobile.addClass('active')
        hamburguer.addClass('top')
        listaM.addClass('active')
        popup.addClass('active')
        bar.addClass('none')
        cart.addClass('scrolling')

        if ($(window).width() <= 1024) {
            menu.addClass('scroll')
        }
    } else {
        nav.removeClass('active')
        lista.removeClass('active')
        down.removeClass('inactive')
        up.removeClass('center')
        mobile.removeClass('active')
        hamburguer.removeClass('top')
        listaM.removeClass('active')
        popup.removeClass('active')
        bar.removeClass('none')
        cart.removeClass('scrolling')
        if ($(window).width() <= 1024) {
            menu.removeClass('scroll')
        }
    }
})

// ____ C O O K I E S ____

if (localStorage.getItem('alqqamar_cookie')) {
    $('.announcement-bar').hide().addClass('inactive')
    $('#mobile').addClass('margin')
    $('#menu').addClass('margin')
} else {
    $('.announcement-bar').show().removeClass('inactive')
    $('#close-bar').click((e) => {
        e.preventDefault()
        localStorage.setItem('alqqamar_bar', 'true')
        $('.announcement-bar').hide().addClass('inactive')
        $('#mobile').addClass('margin')
        $('#menu').addClass('margin')
    })
}

// ____ S L I D E  H O M E ____

$('.slide__images').slick({
    dots: true,
    arrows: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
})

// ____ P O P  U P ____

$('.card_popup').click(function () {
    let obj = $(this).data('card')
    let term = $(this).data('term')
    console.log(obj)
    $('#popup_inner').empty()
    $('.boutique__mask').fadeIn(50)
    $.ajax({
        type: 'POST',
        dataType: 'html',
        url: cltvo_js_lets.ajax_url,
        data: { action: 'card', card_id: obj, term_id: term },
        success: function (data) {
            $('#popup').fadeIn(400).addClass('show')
            $('#popup').html(data)
            $('.popup .close').on('click', function () {
                console.log('close pop')
                $('#popup').fadeOut(300).removeClass('show')
                $('#popup_inner').empty()
            })
        },
        error: function (errors) {
            console.log(errors)
        },
        complete: function () {
            $('.boutique__mask').fadeOut(30)
            parallax_images()
        },
    })
})

$('.popup .close').on('click', function () {
    $('#popup').removeClass('show')
    $('#popup_inner').empty()
})

$('.slider-for').slick({
    infinite: false,
    swipe: false,
    autoplay: false,
    slidesToShow: 1,
    arrows: false,
    draggable: false,
    fade: true,
    asNavFor: '.slider-nav',
})
$('.slider-nav').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: false,
    focusOnSelect: true,
    responsive: [
        {
            breakpoint: 650,
            settings: {
                arrows: false,
                slidesToShow: 6,
                slidesToScroll: 1,
            },
        },
    ],
})
$('div[data-slick]').click(function (e) {
    $('div[data-slick]').removeClass('active')
    $(this).addClass('active')
    e.preventDefault()
    let slideno = $(this).data('slick')
    $('.slider-for').slick('slickGoTo', slideno)
})

// ____ A C O R D E O N  P R O D U C T ____

$('.product__info-detail').on('click', 'h2', function () {
    let t = $(this)
    let tp = t.next()
    let p = t.parent().siblings().find('.detail')
    tp.slideToggle()
    p.slideUp()
    console.log('click')
})

/* $('#shop').on('click', function(){
    console.log('click');
    $('#pop_container').addClass('show');
})
 */

$(function () {
    $('.acordeon').click(function (e) {
        e.preventDefault()

        let contenido = $(this).next('.more_info')

        if (contenido.css('display') == 'none') {
            contenido.slideDown(0)
            $(this).addClass('open')
            $(contenido).addClass('open')
        } else {
            contenido.slideUp(0)
            $(this).removeClass('open')
            $(contenido).removeClass('open')
        }
    })
})

/* F I L T E R S */

/* SYMBOL L i b r a r y */
let types_values = []
function buttonPushed() {
    let m = $.map($(`input[name="symbol_filter"]:checked`), function (i, v) {
        return $(i).val()
    })
    return m
}

const parallax_images = () => {
    let images = gsap.utils.toArray('.parallax_symbol')
    if (images.length) {
        images.forEach(function (element) {
            let speed = parseFloat(element.getAttribute('data-speed'))
            let image = element.querySelector('img')
            if (image && element) {
                gsap.to(image, {
                    yPercent: -150,
                    ease: 'none',
                    scrollTrigger: {
                        trigger: element,
                        scrub: true,
                        start: 'top-=100 bottom',
                        end: 'bottom top',
                        invalidateOnRefresh: true,
                        markers: false,
                    },
                    y: '+=0', // Soluciona un problema de Safari
                })

                gsap.to(element, {
                    y: (image.offsetHeight - element.offsetHeight) * speed,
                    ease: 'none',
                    scrollTrigger: {
                        trigger: element,
                        scrub: true,
                        start: 'top bottom',
                        end: 'bottom top',
                        invalidateOnRefresh: true,
                    },
                })
            }
        })
    }
}

if ($('#symbols_filter').length) {
    console.log('Welcome to Library of S y m b o l s')
    parallax_images()
    $('input[type="checkbox"][name="symbol_filter"]').on('change', function () {
        types_values = buttonPushed()
        if ($(this).hasClass('checked')) {
            $(this).removeClass('checked')
        }
        $('.boutique__mask').fadeIn(50)
        $.ajax({
            type: 'POST',
            dataType: 'html',
            url: cltvo_js_vars.ajax_url,
            data: { action: 'filter_library', type_id: types_values },
            success: function (data) {
                $('#symbols_grid').html(data)
            },
            error: function (errors) {
                console.log(errors)
            },
            complete: function () {
                parallax_images()
                $('.boutique__mask').fadeOut(30)
            },
        })
    })
}

/* DECK D e t a i l */
function getQueryletiable(letiable) {
    let query = window.location.search.substring(1)
    let lets = query.split('&')
    for (let i = 0; i < lets.length; i++) {
        let pair = lets[i].split('=')
        if (pair[0] == letiable) {
            return pair[1]
        }
    }
    return false
}
if ($('#deck_detail').length) {
    console.log('Welcome to Deck D e t a i l s')
    if (window.location.href.indexOf('symbol') != -1) {
        let symbol = getQueryletiable('symbol')
        $('.symbol_link').each(function (i, link) {
            let original_link = $(link).attr('href')
            let new_link = original_link + '/symbol/' + symbol
            $(link).attr('href', new_link)
        })

        if ($('.product_link').length) {
            $('.product_link').each(function (i, link) {
                let original_link = $(link).attr('href')
                let new_link = original_link + '?symbol=' + symbol
                console.log(new_link)
                $(link).attr('href', new_link)
            })
        }
    } else {
        $('.symbol_link').each(function (i, link) {
            $(link).remove()
        })
    }
}

/* PRODUCT S i n g l e */
if ($('#product_single').length) {
    console.log('Welcome to P r o d u c t')
    if (window.location.href.indexOf('symbol') != -1) {
        let symbol = getQueryletiable('symbol')
        $('.symbol_link').each(function (i, link) {
            let original_link = $(link).attr('href')
            let new_link = original_link + '/symbol/' + symbol
            $(link).attr('href', new_link)
        })
    } else {
        $('.symbol_link').each(function (i, link) {
            $(link).remove()
        })
    }
}
$(document).on('submit', '#add-to-cart-form', function (e) {
    e.preventDefault()

    let product_id = $('#product-id').val()
    let product_fields = $(this).serializeArray()
    let fields = []

    if (product_fields.length) {
        product_fields.map((item, key, array) => {
            fields[item.name] = item.value
        })
    }

    let data = {
        action: 'cart',
        //action: 'woocommerce_ajax_add_to_cart',
        product_id: fields['product_id'],
        product_sku: '',
        quantity: 1,
        letiation_id: 0,
    }

    // Verificar si el producto es una Gift Card antes de agregar los campos
    if ($('input[name="wc_gc_giftcard_to_multiple"]').length) {
        console.log('para gift')
        data.wc_gc_giftcard_to_multiple = $(
            'input[name="wc_gc_giftcard_to_multiple"]'
        ).val()
        data.wc_gc_giftcard_from = $('input[name="wc_gc_giftcard_from"]').val()
        data.wc_gc_giftcard_message = $(
            'textarea[name="wc_gc_giftcard_message"]'
        ).val()
        data.wc_gc_giftcard_delivery = $(
            'input[name="wc_gc_giftcard_delivery"]'
        ).val()
        data._wc_gc_giftcard_delivery_gmt_offset = $(
            'input[name="_wc_gc_giftcard_delivery_gmt_offset"]'
        ).val()
    }

    //console.log( wc_add_to_cart_params.ajax_url );
    //console.log( cltvo_js_lets.ajax_url );

    $.ajax({
        type: 'post',
        url: cltvo_js_vars.ajax_url,
        data: data,
        beforeSend: function (response) {
            //$thisbutton.removeClass('added').addClass('loading');
        },
        complete: function (response) {
            //$thisbutton.addClass('added').removeClass('loading');
        },
        success: function (response) {
            $('#sale-popup').addClass('hide')
            $('#close-pop-shop').on('click', function () {
                $('#pop_container').addClass('hide')
            })
            if (response.error && response.product_url) {
                if ($('#pop_container').length) {
                    $('#pop_container').removeClass('hide')
                    console.log('error')
                    $('#popup-bag-img').css('visibility', 'hidden')
                    $('#popup-bag-error').text(
                        'Error: Could not add product to cart.'
                    )
                    $(' .hide_in_error ').remove()
                    console.log(response)

                    setTimeout(function () {
                        $('#pop_container').addClass('hide')
                    }, 5000)
                }

                console.log(response.cart_hash)
                console.log(response.fragments)
            } else {
                //Si se guardó correctamente, mostramos el popup del bag
                if ($('#pop_container').length) {
                    let price = parseInt(fields['product_price'])
                    $('#pop_container').removeClass('hide')
                    $('#popup-bag-title').text(fields['product_title'])
                    $('#popup-bag-price').text(`$ ${price.format(2)}`)
                    $('#popup-bag-img').attr('src', fields['product_thumb'])

                    //Agregamos el contador a las bolsas
                    $('.button--bag').each(function (index, el) {
                        $(el).attr('data-cart-count', response.qty)
                    })

                    setTimeout(function () {
                        $('#pop_container').addClass('hide')
                    }, 8000)
                }

                console.log(response.cart_hash)
                console.log(response.fragments)
                //$(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thisbutton]);
            }

            return
        },
    })
})

Number.prototype.format = function (n, x) {
    let re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')'
    return this.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,')
}
/*END  F I L T E R S */
